module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor03-b98faa0dd604fda4044a0a8d0f0dc938.png";